<template>
  <teleport to="body">
    <div v-if="open" class="modal">
      <div class="product">
        <div class="content">
          <font-awesome-icon class="exit" icon="xmark" @click.stop.prevent="cancel" />

          <h3 class="title">Create/Edit modifier</h3>
          <label v-if="!modifier.name || modifier.name.length == 0">Name</label>
          <input v-if="!modifier.name || modifier.name.length == 0" type="text" v-model="editedModifier.name" placeholder="Name" />
          <h3 v-else>{{ modifier.name }}</h3>

          <div class="toggle-switch">
            <div>
              <label>Active / Available Modifier</label>
              <ToggleSwitch onLabel="Available" offLabel="Unavailable" :modelValue="editedModifier.active" modelName="active" @update:modelValue="save($event, 'active')" />
            </div>
            <!-- <div class="radio-container">
              <h3>Modifier Type</h3>
              <form action="" class="radio">
                <div class="radio-group">
                  <label for="add">Addition</label>
                  <input type="radio" id="add" name="modifierType" value="add" v-model="modifier.type" />
                </div>
                <div class="radio-group">
                  <label for="none">None</label>
                  <input type="radio" id="none" name="modifierType" value="none" v-model="modifier.type" />
                </div>
                <div class="radio-group">
                  <label for="remove">Removal</label>
                  <input type="radio" id="remove" name="modifierType" value="remove" v-model="modifier.type" />
                </div>
              </form>
              <sub>This is for the colours shown on KDS</sub>
            </div> -->
          </div>

          <label>Description</label>
          <input type="text" v-model="editedModifier.desc" />

          <label>Quantity</label>
          <input type="number" v-model.number="editedModifier.quantity" placeholder="0" />

          <label>Modifier Price</label>
          <input type="number" v-model.number="editedModifier.price" placeholder="0" />

          <div class="allergen">
            <label for="allergen">Allergens</label>
            <AllergensList @allergenChanged="changeAllergens" :allergens="editedModifier.allergens" />
          </div>
        </div>

        <div class="overlay">
          <div class="actions footer">
            <button class="action danger" @click.prevent.stop="remove">Delete</button>
            <button class="action cancel cancel-text" @click.prevent.stop="cancel">Cancel</button>
            <button class="action action-colour" @click.prevent.stop="commit()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import ToggleSwitch from "./ToggleSwitch.vue";
import AllergensList from "./AllergenList.vue";

export default {
  name: "ModifierModal",
  props: {
    open: { type: Boolean, required: true },
    modifier: { type: Object, required: true },
    modifierset: { type: Object, required: false },
  },
  emits: ["closeModal", "commit", "remove"],
  components: {
    ToggleSwitch,
    AllergensList,
  },
  data() {
    return {
      showModal: false,
      editedModifier: {},
    };
  },

  methods: {
    save(value, key) {
      this.editedModifier[key] = value;
    },

    remove() {
      this.$emit("remove", this.editedModifier);
    },

    commit() {
      this.$emit("commit", this.editedModifier);
    },

    cancel() {
      let path = this.$route.fullPath.split("/");
      path.pop();
      this.$router.push(path.join("/"));
      this.$emit("closeModal");
    },

    changeAllergens(allergens) {
      this.editedModifier.allergens = allergens;
    },
  },
  watch: {
    modifier() {
      // Create a deep copy of the prop when it changes
      const defaultModifier = {
        name: null,
        desc: null,
        price: 0,
        quantity: 0,
        allergens: [
          { name: "Celery", contains: false },
          { name: "Gluten", contains: false },
          { name: "Crustacean", contains: false },
          { name: "Egg", contains: false },
          { name: "Fish", contains: false },
          { name: "Lupin", contains: false },
          { name: "Milk", contains: false },
          { name: "Mollusc", contains: false },
          { name: "Mustard", contains: false },
          { name: "Tree Nut", contains: false },
          { name: "Peanut", contains: false },
          { name: "Sesame Seed", contains: false },
          { name: "Soya", contains: false },
          { name: "Sulphur Dioxide", contains: false },
        ],
        active: false,
        type: "none",
      };

      this.editedModifier = JSON.parse(JSON.stringify(this.modifier || defaultModifier));

      // Ensure allergens are in the correct format for AllergenList
      if (this.editedModifier.allergens && this.editedModifier.allergens.length > 0) {
        // If allergens exist but don't have the right structure, merge with defaults
        if (!this.editedModifier.allergens[0].hasOwnProperty("contains")) {
          const existingAllergens = this.editedModifier.allergens;
          this.editedModifier.allergens = defaultModifier.allergens.map((allergen) => ({
            ...allergen,
            contains: existingAllergens.some((existing) => existing.name === allergen.name || existing === allergen.name),
          }));
        }
      } else {
        this.editedModifier.allergens = defaultModifier.allergens;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@monolith/styles";

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
  .product {
    height: 100%;
    display: flex;
    overflow-y: auto;

    .content {
      padding-bottom: 5rem;
      .toggle-switch {
        width: calc(100% - 2rem);
        margin: 0.5rem;
        display: flex;
        justify-content: space-between;
        .radio-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          h3 {
            margin: 0.25rem;
          }
          sub {
            color: var(--action-colour);
          }
          .radio {
            display: inherit;
            .radio-group {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin: 0.5rem;
              input {
                appearance: none;
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 50%;
                border: 2px solid var(--action-colour);
                background-color: var(--secondary-colour);
                box-shadow: var(--box-shadow);
                &:checked {
                  background-color: var(--action-colour);
                }
              }
            }
          }
        }
      }
    }

    .overlay {
      display: flex;
      flex-direction: column;
      flex: 1;
      position: absolute;
      bottom: 2rem;
      min-width: 80vw;
      max-width: 90vw;
      z-index: 1000;

      .footer {
        position: relative;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        z-index: 1;
        display: flex;
        justify-content: space-between;

        &::before {
          content: "";
          position: absolute;
          top: 5px;
          left: -1rem;
          right: -1rem;
          bottom: 5px;
          background-color: rgba(109, 109, 109, 0.7);
          z-index: -1;
        }
      }
    }
  }
}

.blue {
  background-color: var(--action-colour);
  color: var(--secondary-text-colour);
}

.cancel-text {
  background-color: var(--primary-colour) !important;
}

input {
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  margin-left: 0.25rem;
}
.mod-select {
  h3 {
    margin: 0;
  }
  .set {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    width: 80vw;
    //remove scrollbar
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    .mods-in-set {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: wrap;
      margin: 0.5rem;
      padding: 0.5rem;
      border-radius: 10px;
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      cursor: pointer;
      p {
        text-wrap: wrap;
        width: 7rem;
      }
      &:active {
        box-shadow: none;
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  .actions {
    align-items: center !important;
    justify-content: center !important;
    justify-items: center !important;
    .danger {
      margin-right: 3.5rem !important;
    }
  }
}
</style>
